import { useState } from 'react';

export function useUpdateState(objectData) {
  const [state, setState] = useState(objectData);

  const updateState = (data) => setState((state) => ({ ...state, ...data }));

  return [state, updateState];
}
